<template>
    <Modal :visible="visible" @update:visible="v => $emit('update:visible', v)">
        <template v-slot:title>
            {{ __('actions.load_thing', {thing: __('general.template')}) }}
        </template>

        <table class="table table-hover table-vertical-center">
            <thead>
            <tr>
                <th>{{ __('general.name') }}</th>
                <th class="text-right">{{ __('general.action') }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="template in templates">
                <td>{{ template.name }}</td>
                <td class="text-right">
                    <button class="btn btn-xs btn-light-danger" @click="deleteTemplate(template)">
                        <i class="fas fa-trash p-0"/>
                    </button>
                    <button class="btn btn-xs btn-primary" @click="$emit('template:load', template)">
                        <i class="fas fa-upload"/>
                        {{ __('actions.load_thing', {thing: __('general.template')}) }}
                    </button>
                </td>
            </tr>
            </tbody>
        </table>
    </Modal>
</template>

<script>
import Modal from "@components/Modal.vue";

export default {
    components: {Modal},

    emits: [
        'template:load',
        'update:visible'
    ],

    props: {
        templates: Array,
        visible: Boolean,
    },

    methods: {
        deleteTemplate(template) {
            Swal.fire({
                title: __('actions.remove_thing', {thing: template.name}) + `?`,
                confirmButtonText: __('actions.remove'),
                cancelButtonText: __('actions.abort'),
                showCancelButton: true,
                customClass: {
                    confirmButton: "btn btn-danger m-0",
                },
            }).then((result) => {
                if (result.value) {
                    this.$inertia.delete(this.$route('offers.widgets.templates.delete', template.id), {
                        only: ['templates'],
                        preserveState: true,
                        onSuccess: () => {
                            toastr.warning(__('general.thing.deleted', {thing: template.name}))
                        }
                    });
                }
            })
        }
    }
}
</script>
